import { toast } from 'react-toastify';
import './index.css';
import TableLoading from './TableLoading';
import { Context } from '../../../config/store';
import React, { useState } from 'react';
import { unSecuredIds } from '../../../constant/constants';
import Hint from '../../Hint';

/**
 *
 * @param {Boolean} checkbox
 * @param {Array} tableHeaders
 * @param {Array} rows
 * @param {Function} update
 */
//  replyQuery={changePage}
export default function Table({
	rows,
	headerCheckboxUpdateCallback,
	rowCheckboxUpdateCallback,
	checkbox,
	customCheck,
	checkDoaLogs=false,
	headerChecked,
	columns,
	children,
	onSortChange,
	type,
	loading,
	tableExtraClass,
	reloadTable,
	showHeaderCheckbox,
	click,
	isDocumentSubmitting = -1,
	tableName = '',
	selectedLender = '',
	selectedIds,
	hint=false,
	...rest
}) {
	const { state } = React.useContext(Context);
	const headerCheckboxHandler = (e) => {
		let tableData = rows;

		for (var i = 0; i < tableData.length; i++) {
			if (customCheck(tableData[i])) tableData[i].checked = e.target.checked;
		}

		headerCheckboxUpdateCallback(e.target.checked, tableData);
	};

	const rowCheckboxHandler = (e, i) => {
		let tableData = rows;
		if ((tableName == 'DOA' && selectedLender == '1') && unSecuredIds.includes(tableData?.[i]?.prod_type)) {
			if (tableData[i]?.doa_additional_info) {
				tableData[i].checked = e.target.checked;
			} else {
				toast.warning('Please fill CGPan Info')
				tableData[i].checked = false;
			}
		} else {
			tableData[i].checked = e.target.checked;
		}

		let selectedRowCount = tableData.filter((el) => {
			return el.checked;
		}).length;
		if(showHeaderCheckbox){
			if(selectedRowCount == rows.length){
				headerCheckboxUpdateCallback(true, rows)
			}else{
				headerCheckboxUpdateCallback(false, rows)
			}
		}
		// setIsDocumentSubmmiting(false)
		rowCheckboxUpdateCallback(tableData, selectedRowCount, e.target.checked, i);
	};

	const rowRenderer = () => {
		const checkboxHandler = (i) => (e) => {
			// setIsDocumentSubmmiting(true)
			rowCheckboxHandler(e, i);
		};
		const checkHasPermission = (checkPermission) => {
			if (state.is_super_admin === 1) return true;
			const permission = state.permission.find(
				(permission) => permission === checkPermission
			);

			if (permission) return true;
			else return false;
		};

		return rows?.map((row, i) => {
			return (
				<tr key={i+'_'+Date.now()}>
					{Boolean(checkbox) &&
						((customCheck ? customCheck(row, i) : Boolean(checkbox)) ? (
							<td>
								{checkHasPermission('document-submit-to-lender') &&
									<input
										type='checkbox'
										checked={row.checked || selectedIds?.[row.laf_id]}
										id={'row-checkbox-' + i}
										onChange={checkboxHandler(i)}
										disabled={isDocumentSubmitting == i ? true : false}
									>
									</input>
								}
							</td>
						) : (
							<td>
								{(checkDoaLogs ? checkDoaLogs(row, i) : false) && checkHasPermission('document-submit-to-lender') && hint &&
									<Hint text={'API Failure recorded, Please re-submit CGPAN Details.'} id={`doalog-${row?.cl_lead_id}`} place='top' customStyle={{'font-size': '20px', 'color': '#dc3545'}}></Hint>}
							</td>
						))}
					{columns.map(
						(
							{ field, rowClass, component: Component, ...otherProps },
							index
						) => (
							<td key={index} className={rowClass}>
								{Component ? (
									<Component
										row={row}
										field={field}
										reloadTable={reloadTable}
										index={i}
										otherProps={otherProps}
										selectedLender={selectedLender}
										{...rest}
									/>
								) : row[field] || typeof row[field] === 'number' ? (
									row['alias_name'] ? row['alias_name'] : row[field]
								) : (
									'---'
								)}
							</td>
						)
					)}
				</tr>
			);
		});
	};

	const childrenWithProps = React.Children.map(children, (child) => {
		// Checking isValidElement is the safe way and avoids a typescript
		// error too.
		if (React.isValidElement(child)) {
			return React.cloneElement(child, {});
		}
		return child;
	});

	return (
		<div className='table_section'>
			<div className='row'>
				<div className='col-md-12'>
					<div className='table-responsive'>
						<table className={'table table-striped ' + tableExtraClass}>
							<Header
								columns={columns}
								headerCheckboxHandler={headerCheckboxHandler}
								headerChecked={headerChecked}
								checkbox={checkbox}
								onSortChange={onSortChange}
								showHeaderCheckbox={showHeaderCheckbox}
							/>
							<tbody className='position-relative'>
								{loading && <TableLoading />}
								{children ? childrenWithProps : rowRenderer()}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
}
const Thead = ({ title, sort, field, onSortChange, i }) => {
	const [sortOrder, toggleSortOrder] = React.useState(false);
	const onSort = (sortFeild) => {
		if (onSortChange) {
			onSortChange({
				sortBy: sortFeild,
				sortOrder: sortOrder ? 'ASC' : 'DESC',
			});
		}
		toggleSortOrder(!sortOrder);
	};
	return (
		<th
			onClick={sort ? () => onSort(field) : () => { }}
			className={title === 'Action' || title === 'ROI' ? 'no-wrap' : ''}
		>
			{title}
			{sort && (
				<span>
					{' '}
					{sortOrder ? (
						<i class='fa fa-arrow-up' aria-hidden='true'></i>
					) : (
						<i class='fa fa-arrow-down' aria-hidden='true'></i>
					)}
				</span>
			)}
		</th>
	);
};

const Header = ({
	showHeaderCheckbox,
	checkbox,
	columns,
	headerChecked,
	headerCheckboxHandler,
	onSortChange,
}) => {
	return (
		<thead>
			<tr>
				{Boolean(checkbox) &&
					(Boolean(showHeaderCheckbox) ? (
						<th>
							<input
								type='checkbox'
								checked={headerChecked}
								id='header-checkbox'
								onChange={headerCheckboxHandler}
							></input>
						</th>
					) : (
						<th></th>
					))}

				{columns.map(({ title, sort, field }, i) => (
					<Thead
						title={title}
						sort={sort}
						onSortChange={onSortChange}
						field={field}
						key={field}
					/>
				))}
			</tr>
		</thead>
	);
};
